import { useNavigate } from 'react-router-dom';
import { logout } from '../../services';

const Logout = ({ className }) => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout()
        navigate('/');
    }

    return (
        <div className={`${className} py-2 px-3 text-tipl-teal text-base font-semibold rounded-lg shadow-md bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-75`}>
            <button onClick={() => handleLogout()}>Log out</button>
        </div>
    );
};

export default Logout;